import { Vue, Options } from 'vue-class-component';
import {
  PlantDTO,
} from '@/../client-generator/generated-clients/plants';
import DialogPlantCreateStep1 from './DialogAutomationPlantCreate/DialogPlantCreateStep1/DialogPlantCreateStep1.vue';
import DialogPlantCreateStep2 from './DialogAutomationPlantCreate/DialogPlantCreateStep2/DialogPlantCreateStep2.vue';
import DialogPlantCreateStep3 from './DialogAutomationPlantCreate/DialogPlantCreateStep3/DialogPlantCreateStep3.vue';

import plantsClient from '@/core/services/plants';
import {
  SET_SELECTED_PLANT_ID,
} from '@/core/store/action-types';
import { defaultNewPlant, cloneObject } from '@/core/utils/utils';
@Options({
  name: 'WizardAutomationPLant',
  components: {
    DialogPlantCreateStep1,
    DialogPlantCreateStep2,
    DialogPlantCreateStep3,
  },
  props: {
    plantId: {
      type: Number,
      required: false,
    },
  },
  emits: ['exit-wizard', 'plant-edited', 'update'],
})
export default class WizardAutomationPLant extends Vue {
  plantId: number | null = null;
  isLoading = false;
  nextEnabled = true;
  dialogStep = 1;
  plant: PlantDTO = cloneObject(defaultNewPlant);

  get dialogStepComponent() {
    return `DialogPlantCreateStep${this.dialogStep}`;
  }
  get buttonSubmitLabel() {
    if (this.plantId) {
      return this.$t('AppResource.Save');
    }
    if (!this.plantId) {
      if (this.dialogStep <= 2) {
        return this.$t('AppResource.Continue');
      }
    }
    return this.$t('AppResource.Create');
  }

  get isBackButtonVisible() {
    return this.dialogStep == 1 ? this.plantId ? false : this.$config.ENTRANCE_PLANT_ENABLED : true;
  }

  mounted(): void {
    this.initFormPlant();
  }

  initFormPlant() {
    if (this.plantId) {
      this.fetchPlantDetails();
    } else {
      this.plant = cloneObject(defaultNewPlant);
    }
  }

  handleNextEnabledChange(e: boolean) {
    this.nextEnabled = e;
  }

  async fetchPlantDetails() {
    this.isLoading = true;

    try {
      this.plant = await plantsClient.plantGET(
        this.plantId as number,
        undefined
      );
      this.plant.roomsCounts = [];
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  async handleButtonSubmitAction() {
    if (this.plantId) {
      await this.handleEditPlant();
    } else {
      if (this.dialogStep <= 2) {
        this.dialogStep++;
      } else {
        const createdPlantId = await this.handleCreatePlant();
        if (createdPlantId) {
          this.goToPlantDetail(createdPlantId, true);
        }
      }
    }
  }

  handleStepBack() {
    if (this.dialogStep == 1) {
      this.plant = cloneObject(defaultNewPlant);
      this.nextEnabled = true;
      this.$emit("exit-wizard");
    }
    this.dialogStep--;
  }

  async handleCreatePlant() {
    let createdPlant = null;
    this.isLoading = true;

    try {
      this.plant.roomsCounts = this.plant.roomsCounts?.filter(
        (room) => (room.count as number) > 0
      );
      createdPlant = await plantsClient.plantPOST(this.plant);
      this.$emit('update', createdPlant)
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 6000,
      });
    } finally {
      this.isLoading = false;
    }

    return createdPlant;
  }

  async handleEditPlant() {
    if (!this.plantId) return;

    this.isLoading = true;

    try {
      await plantsClient.plantPUT(this.plantId, this.plant);
      this.$emit('plant-edited');
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  goToPlantDetail(plantId: number | null, isNew = false) {
    this.$nextTick(async () => {
      await this.$store.dispatch(SET_SELECTED_PLANT_ID, plantId);
      this.$router.push({
        name: 'page-plant-dashboard',
        params: { plantId: plantId?.toString() ?? '' },
      });

      this.$toast.add({
        severity: 'success',
        summary: this.$t(
          isNew ? 'AppResource.PlantCreated' : 'newPlantDialog.modified'
        ),
        closable: false,
        life: 3000,
      });

      const summary = this.$t('general.synced');
      setTimeout(() => {
        this.$toast.add({
          severity: 'success',
          summary: summary,
          closable: false,
          life: 3000,
        });
      }, 1500);
    });
  }

  handleStepLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
